import { Flex, Text, Icon, Button, ButtonProps } from '@chakra-ui/react';
import { IoTicketOutline, IoChevronForward } from 'react-icons/io5';
import {
  FloatingLabel,
  FloatingLabelContainer,
  FloatingLabelInput,
} from 'src/components/Inputs/FloatingLabel';
import { useParams } from 'react-router-dom';
import { ChangeEvent, FormEvent, useEffect, useRef, useState } from 'react';
import { RouteParamsEvent } from 'src/types/routing';
import { useCheckoutStore, useDiscountStore } from '../../stores';

export const CouponApplication: React.FC<ButtonProps> = props => {

  const discountStore = useDiscountStore();
  const { getEventCheckout } = useCheckoutStore();
  const { eventID } = useParams<RouteParamsEvent>();
  const [coupon, setCoupon] = useState('');
  const [isVisible, setVisible] = useState(false);
  const initialFocusRef = useRef<HTMLInputElement>(null);

  const sellId = getEventCheckout(eventID!).sellId;

  const handleOnClick = () => {
    setVisible(true);
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setCoupon(event.target.value.replace(/\s/g, '').toUpperCase());
  };

  const { mutate } = discountStore.useApplyMutation();

  const handleOnSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!!coupon) {
      mutate({
        sellId,
        eventId: eventID!,
        couponName: coupon,
      });
    }
  };

  useEffect(() => {
    if (isVisible && initialFocusRef.current) {
      initialFocusRef.current.focus();
    }
  }, [isVisible]);

  if (!isVisible) {
    return (
      <Button
        onClick={handleOnClick}
        alignItems="center"
        colorScheme="gray"
        variant="ghost"
        w="100%"
        h="46px"
        {...props}>
        <Icon color="black" mr="4" boxSize="5" as={IoTicketOutline} />
        <Text color="gray" fontWeight="semibold">
          Adicionar cupom
        </Text>
        <Icon color="black" ml="auto" boxSize="5" as={IoChevronForward} />
      </Button>
    );
  }

  return (
    <Flex
      as="form"
      noValidate
      // @ts-ignore
      onSubmit={handleOnSubmit}
      direction="row"
      align="center"
      {...props}>
      <FloatingLabelContainer>
        <FloatingLabelInput
          value={coupon}
          onChange={handleOnChange}
          ref={initialFocusRef}
        />
        <FloatingLabel>Código de cupom</FloatingLabel>
      </FloatingLabelContainer>

      <Button
        type="submit"
        colorScheme="gray"
        color="brand.500"
        variant="ghost"
        fontWeight="semibold"
        ml="4"
        isDisabled={!coupon}>
        Adicionar
      </Button>
    </Flex>
  );
};